const loadItems = (button) => {
  const totalPages = parseInt($('[data-total-pages]').val());
  let currentPage = parseInt($('[data-current-page]').val());
  let currentPageScroll = currentPage + 1;

  currentPage = currentPage+1;
  const nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPage);
  const nextUrlScroll = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPageScroll);
  $('[data-current-page]').val(currentPage);

  button.setAttribute("disabled", "");
  button.classList.add('loading');

  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function(responseHTML){
      $('.load-more-grid').append($(responseHTML).find('.load-more-grid').html());
      colorSwatches();
      resortAvailability();
    },
    complete: function() {
      if (currentPage <= totalPages) {
        const scollData = document.querySelector('.infinite-scroll__data');
        if (scollData && currentPage != totalPages) {
          scollData.querySelector('input[data-next-url]').dataset.nextUrl =  nextUrlScroll;
          scollData.querySelector('input[data-next-url]').value =  nextUrlScroll;
          scollData.querySelector('input[data-current-page]').dataset.currentPage =  currentPage;
          scollData.querySelector('input[data-current-page]').value =  currentPage;
          checkVisibility();
        }
        button.removeAttribute("disabled");
        button.classList.remove('loading');
        if (currentPage == totalPages) {
          button.remove();
        }
      }
    }
  })
}

/*
  OUTNEST — voorraad-bewuste her-sortering na "toon meer" (1 sep 2026)
  ------------------------------------------------------------------
  Elke server-render (één Liquid-pagina van section main-collection-product-grid)
  sorteert al beschikbaar-eerst/uitverkocht-laatst, maar ALLEEN binnen die ene
  pagina — Shopify's paginate-tag kent de rest van de collectie niet. Zonder
  deze stap eindigde pagina 1 dus met een blok uitverkochte kaarten net vóór de
  "toon meer"-knop, terwijl pagina 2 daarna weer kaarten toont die WEL op
  voorraad zijn — het leek dan alsof de collectie leeg raakte, terwijl er
  verderop nog volop voorraad stond.
  Deze functie herschikt na elke AJAX-append de VOLLEDIGE, tot dan toe
  geladen kaartenset opnieuw: alle beschikbare kaarten eerst, alle
  uitverkochte kaarten daarna — over paginagrenzen heen. De WhatsApp-banner
  (.cg-banner, alleen op pagina 1 aanwezig) blijft altijd op dezelfde
  kaart-positie staan (na de 12e kaart in de nieuwe volgorde), ongeacht welke
  kaarten daar na het herschikken staan — hij is voller-breedte en breekt de
  kolomtelling toch al bewust open, dus verschuift zonder visueel probleem.
*/
const resortAvailability = () => {
  const grid = document.querySelector('.load-more-grid');
  if (!grid) return;

  const children = Array.from(grid.children);
  const banners = children.filter(li => li.querySelector('.cg-banner'));
  const cards = children.filter(li => !li.querySelector('.cg-banner'));

  const isSoldOut = (li) => !!li.querySelector('.badge--soldout');
  const available = cards.filter(li => !isSoldOut(li));
  const soldOut = cards.filter(li => isSoldOut(li));

  const orderedCards = available.concat(soldOut);
  const bannerInsertAt = 12;

  orderedCards.forEach((li, i) => {
    if (i === bannerInsertAt && banners.length) {
      grid.appendChild(banners.shift());
    }
    grid.appendChild(li);
  });
  // Resterende banners (zou niet moeten voorkomen — er is er maar één per pagina 1)
  banners.forEach(b => grid.appendChild(b));
};

const checkVisibility = () => {
  const spinnerList = document.querySelectorAll('.js-infinite-scroll');
  spinnerList.forEach(spinner => {
    const sectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            loadItems(spinner);
            sectionObserver.unobserve(entry.target);
          }
        })
      }
    );

    sectionObserver.observe(spinner);
  })
}

function loadMore() {
  document.querySelectorAll('.js-load-more').forEach((button) => {
    button.onclick = () => {
      loadItems(button);
    }
  });

  checkVisibility();
}

(function () {
  loadMore();
})();
